import { Button } from '../components/atoms/Button/Button';
import { Textbox } from '../components/organisms/Textbox';
import React, { useCallback } from 'react';
import client from '../tina/__generated__/client';
import { ContactQuery, Exact } from '../tina/__generated__/types';
import { useTina } from 'tinacms/dist/react';
import { Cover1 } from '../components/organisms/Cover1/Cover1';
import { CopyText, StyledLink } from 'shared/Typography';
import { Flex } from '../components/atoms/Flex';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { PHONE_REG_EXP } from 'shared/Helper';
import { yupResolver } from '@hookform/resolvers/yup';
import { NextSeoProps } from 'next-seo/lib/types';
import { NextSeo } from 'next-seo';

const validateRequired = (value: string) => {
  return value.length > 0;
};

async function postData(url = '', data = {}) {
  const formData = new FormData();
  for (const key in data) {
    // @ts-ignore
    formData.append(key, data[key]);
  }

  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST',
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    mode: 'no-cors',
    body: formData, // body data type must match "Content-Type" header
  });
  return response; // parses JSON response into native JavaScript objects
}

export default function Kontakt(props: {
  query: string;
  variables: Exact<{ relativePath: string }>;
  data: ContactQuery;
}) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  const [submitted, setSubmitted] = React.useState(false);

  const schema = yup.object().shape({
    nachname: yup.string().required(),
    vorname: yup.string(),
    email: yup
      .string()
      .email('Das ist keine gültige E-Mail Adresse')
      .required(),
    telefon: yup
      .string()
      .matches(PHONE_REG_EXP, 'Das ist keine gültige Telefonnummer'),
    anfrage: yup.string().required(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = async (data: any) => {
    const result = await postData('https://form.taxi/s/hb4fiyl6', data);

    setSubmitted(true);
    reset();
  };
  console.log(errors);

  return (
    <>
      <NextSeo {...(data.contact.seo as NextSeoProps)} />
      <Cover1 {...data.contact.cover}>
        <CopyText
          variant={{ '@initial': 'h4', '@tabletAndUp': 'h4TabletAndUp' }}
        >
          <br />
          <p>
            Telefon:
            <br />
            <StyledLink
              variant={{
                '@initial': 'h4Link',
                '@tabletAndUp': 'h4LinkTabletAndUp',
              }}
              href="tel:004366488463160"
            >
              +43 664 88 46 31 60
            </StyledLink>
          </p>
          <br />
          <p>
            E-Mail: <br />{' '}
            <StyledLink
              variant={{
                '@initial': 'h4Link',
                '@tabletAndUp': 'h4LinkTabletAndUp',
              }}
              href="mailto:office@fenster-sachverstaendiger.com"
            >
              office@fenster-sachverstaendiger.com
            </StyledLink>
          </p>
        </CopyText>
      </Cover1>

      <Flex
        css={{
          flexDirection: 'column',
          paddingBlock: '$spacing-5x',
          paddingInline: '$spacingMainMobile',
          '@tabletAndUp': {
            paddingBlock: '$spacing-7x',
          },
        }}
      >
        <Flex
          css={{
            flexDirection: 'column',
            maxWidth: '$tablet',
            margin: 'auto',
            gap: '$spacing-2x',
            width: '100%',
          }}
        >
          {submitted && (
            <>
              <CopyText variant="h3">Vielen Dank für Ihre Anfrage!</CopyText>
              <CopyText>
                Ihre Nachricht wurde erfolgreich versandt.
                <br />
                Ich melde mich in Kürze bei Ihnen.
              </CopyText>
            </>
          )}
          {!submitted && (
            <form
              id="kontaktformular" /*action="https://form.taxi/s/hb4fiyl6" method="POST"*/
              onSubmit={handleSubmit(onSubmit)}
            >
              <div>
                <Textbox
                  formId="kontaktformular"
                  fieldId="nachname"
                  label="Nachname*"
                  required
                  registrationFunction={register}
                  invalidMessage={errors.nachname?.message as string}
                />
              </div>
              <div>
                <Textbox
                  formId="kontaktformular"
                  fieldId="vorname"
                  label="Vorname"
                  registrationFunction={register}
                  invalidMessage={errors.vorname?.message as string}
                />
              </div>
              <div>
                <Textbox
                  formId="kontaktformular"
                  fieldId="email"
                  label="E-Mail*"
                  type="email"
                  required
                  registrationFunction={register}
                  invalidMessage={errors.email?.message as string}
                />
              </div>
              <div>
                <Textbox
                  formId="kontaktformular"
                  fieldId="telefon"
                  label="Telefonnummer für Rückruf"
                  type="tel"
                  registrationFunction={register}
                  invalidMessage={errors.telefon?.message as string}
                />
              </div>
              <div>
                <Textbox
                  formId="kontaktformular"
                  fieldId="anfrage"
                  label="Anfrage*"
                  multiline={true}
                  required
                  registrationFunction={register}
                  invalidMessage={errors.anfrage?.message as string}
                />
              </div>
              <Button fullWidth>
                <input type="submit" value={'Jetzt Anfrage absenden'}></input>
              </Button>
            </form>
          )}
        </Flex>
      </Flex>
    </>
  );
}

export const getStaticProps = async () => {
  const pageResponse = await client.queries.contact({
    relativePath: 'kontakt.mdx',
  });

  return {
    props: {
      data: pageResponse.data,
      query: pageResponse.query,
      variables: pageResponse.variables,
    },
  };
};
